/**
 * Created by AlexanderC on 5/22/15.
 *
 * Bootstrap file loaded by npm as main
 */

'use strict';

var _Security = require('./Security');

module.exports = _Security.Security;


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/bootstrap.js
// module id = 454
// module chunks = 0